import axios from "axios";
import { retrieveData } from "../LocalConnection/LocalConnection";

let APIURL = "https://www.superpanel.vedicastrologyforum.com/";
let APIURL_spring_boot = "http://13.233.26.140:8080/";
APIURL_spring_boot = "https://api.vedicastrologyforum.com/";
// APIURL = 'https://www.superpanel.vedicastrologyforum.com/';
const website_URL_main = "astro_main";
const Globel_TOKEN = "global_astro";
const APP_STORE_ID = "your-app-store-id";
const PLAY_STORE_ID = "your.package.name";
const GOOGLE_PLACES_API_KEY = "AIzaSyC3WmMY1uBgZmeiAPftovjM_tY0vbUi3Zs";
const payment_key = "M22NVWSO2VDZG";

const APIURL_CON = APIURL + "Android/";

const Login_url = APIURL_CON + "login_user";
const astrologer_url = APIURL_CON + "astrologer_url";
const privacy_link = APIURL_CON + "privacy_link";
const philosophy_link = APIURL_CON + "philosophy_link";
const terms_link = APIURL_CON + "terms_link";
const support_link = APIURL_CON + "support_link";
const call_price_link = APIURL_CON + "call_price_link";
const personalized_reading_link = APIURL_CON + "personalized_reading_link";
const daily_prediction_link = APIURL_CON + "daily_prediction_link";
const view_subjecsts = APIURL_CON + "view_subjecsts";
const query_horoscope = APIURL_CON + "query_horoscope";
const query_marriagee_save = APIURL_CON + "query_marriagee_save";
const view_question_detail = APIURL_CON + "view_question_detail";
const dashboard_url = APIURL_CON + "dashboard_url";
const create_Matchmaking = APIURL_CON + "create_Matchmaking";
const create_horoscope = APIURL_CON + "create_horoscope";
const delete_for_android = APIURL_CON + "delete_for_android";
const save_message_url = APIURL_CON + "save_message";
const like_dislike_msge_url = APIURL_CON + "like_dislike_msg";
const update_profile_url = APIURL_CON + "update_profile";
const update_query_marriagee_save = APIURL_CON + "update_query_marriagee_save";
const get_marriagee_data = APIURL_CON + "get_marriagee_data";
const get_timezone_data = APIURL_CON + "get_timezone_data";
const get_all_khudali_data = APIURL_CON + "get_all_khudali_data";
const get_price_data = APIURL_CON + "get_price_data";
const get_all_unread_primum_astrogloy_reply =
  APIURL_CON + "get_all_unread_primum_astrogloy_reply";
const get_daily_prediction = APIURL_CON + "get_daily_prediction";
const delete_account = APIURL_CON + "delete_account";
const playStoreLink = APIURL_CON + "open_appweb";
const get_khudali_data = APIURL_CON + "get_khudali_data";
// spring boot api
const panchang = APIURL_spring_boot + "panchang";
const Kundli = APIURL_spring_boot + "kundli";
const match = APIURL_spring_boot + "match";

/**website links */
// Retrieving data

const server_post_data = async (url_for, Data) => {
  if (Data === null) {
    Data = new FormData();
  }

  let customer_id = retrieveData("customer_id");
  if (customer_id === null || customer_id === 0) {
    customer_id = 0;
  }
  Data.append("token", "q");
  Data.append("key_secret", "astro@2023");
  Data.append("app_web", "reactnative");
  Data.append("web_app", "Web");
  Data.append("cd_id", customer_id);

  const response = await axios.post(url_for, Data, {
    headers: {
      "X-Package-Name": website_URL_main,
      "Content-Type": "multipart/form-data", // If you're sending form data
    },
  });
  return response.data;
};

const sendKundliData = async (url_for, Data) => {
  if (Data === null) {
    Data = new FormData();
  }
  let customer_id = retrieveData("customer_id");
  if (customer_id === null || customer_id === 0) {
    customer_id = 0;
  }
  Data.append("token", "q");
  Data.append("key_secret", "astro@2023");
  Data.append("app_web", "reactnative");
  Data.append("web_app", "Web");
  Data.append("cd_id", customer_id);
  const response = await axios.post(url_for, Data, {
    headers: {
      "X-Package-Name": website_URL_main,
      "Content-Type": "multipart/form-data", // If you're sending form data
    },
    maxRedirects: 0, // Don't follow redirects
  });
  return response.data;
};

export {
  APIURL,
  APP_STORE_ID,
  astrologer_url,
  call_price_link,
  create_horoscope,
  create_Matchmaking,
  daily_prediction_link,
  dashboard_url,
  delete_for_android,
  Globel_TOKEN,
  GOOGLE_PLACES_API_KEY,
  Kundli,
  like_dislike_msge_url,
  Login_url,
  match,
  // spring boot api
  panchang,
  personalized_reading_link,
  philosophy_link,
  PLAY_STORE_ID,
  privacy_link,
  query_horoscope,
  query_marriagee_save,
  get_marriagee_data,
  save_message_url,
  sendKundliData,
  server_post_data,
  //third party
  update_profile_url,
  get_timezone_data,
  update_query_marriagee_save,
  get_all_unread_primum_astrogloy_reply,
  view_question_detail,
  view_subjecsts,
  get_all_khudali_data,
  get_price_data,
  get_khudali_data,
  website_URL_main,
  payment_key,
  terms_link,
  support_link,
  delete_account,
  get_daily_prediction,
  playStoreLink,
};
